/*
 * File: MainDrawer.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the navigation menu
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Drawer, Hidden, Divider, Typography, Link } from "@material-ui/core";
import DrawerLinkItems from "./DrawerLinkItems";
import LoggedInUser from "./LoggedInUser";
import PropTypes from "prop-types";

const drawerWidth = 240;

const styles = theme => ({
  drawer: {
    [theme.breakpoints.up("md")]: {
      width: drawerWidth
    }
  },
  drawerPaper: {
    width: drawerWidth,
    background: theme.palette.primary.main
  },
  toolbarIe11: {
    display: "flex"
  },
  toolbar: {
    ...theme.mixins.toolbar,
    paddingLeft: theme.spacing(3),
    display: "flex",
    flex: 1,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    background: theme.palette.secondary,
    color: theme.palette.common.white
  },
  version: {
    color: theme.palette.common.white,
    textAlign: "center"
  },
  acknowledgments: {
    color: theme.palette.common.white,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    textAlign: "center",
    fontSize: "0.8em"
  }
});

const MainDrawer = ({ classes, mobileOpen, handleDrawerToggle }) => {
  const drawer = (
    <React.Fragment>
      <div className={classes.nav}>
        <div className={classes.toolbarIe11}>
          <div className={classes.toolbar}>
            <LoggedInUser />
          </div>
        </div>
        <DrawerLinkItems handleDrawerToggle={handleDrawerToggle} />
      </div>
      <div style={{ flexGrow: 1 }} />
      <Typography className={classes.version}>
        Version {process.env.REACT_APP_VERSION}
      </Typography>
      <Link
        className={classes.acknowledgments}
        href={"https://helpdesk.macpractice.net/hc/en-us/articles/215594318"}
      >
        Acknowledgments
      </Link>
    </React.Fragment>
  );

  return (
    <nav className={classes.drawer}>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          anchor="left"
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Divider />
        <Drawer
          variant="permanent"
          anchor="left"
          open
          classes={{
            paper: classes.drawerPaper
          }}
        >
          {drawer}
        </Drawer>
      </Hidden>
    </nav>
  );
};

MainDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
  mobileOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired
};

export default withStyles(styles)(MainDrawer);
